import * as React from 'react'
import classNames from 'classnames'

import { HeadlineTwo } from 'content-components/_Primatives/Headlines'
import HeadlineThree from '../../00-Primitives/Headlines/HeadlineThree'
import Button from 'content-components/_Primatives/Button'

import style from './style.scss'
import MediaQuery from '../../MediaQuery'

export type SearchInputProps = {
  className?: string
  handleInputChange?: (arg0: string) => void
  restrictedLanguages?: string
  resultsPageUrl?: string
  searchResultsLabelText?: string
  searchTitleText: string
  submitButtonText: string
  type?: 'searchbox-only' | 'searchbox'
}

type Props = SearchInputProps & {
  newWindow?: 'true' | 'false'
  query?: string
}

class SearchInput extends React.PureComponent<Props> {
  static defaultProps = {
    className: '',
    handleInputChange: undefined,
    newWindow: 'false',
    query: '',
    restrictedLanguages: '',
    searchResultsLabelText: 'Get search results',
    type: 'searchbox',
    resultsPageUrl: '/search',
  }

  componentDidMount() {
    window.__gcse = {
      callback: this.setupGoogleWatchers,
    }
  }

  /**
   * @description this function will send out the initial input query pulled from the Redux state props.
   */
  setupGoogleWatchers = () => {
    const { query, type, handleInputChange } = this.props

    if (query) {
      const inputArea = document.getElementById('gsc-i-id1')
      if (inputArea) {
        inputArea.setAttribute('value', query)
      }
      this.handleSubmit()
    }
    if (type === 'searchbox-only' && handleInputChange) {
      const inputFocus = document.getElementsByClassName(
        'gsc-input',
      )[0] as HTMLInputElement | null
      if (inputFocus) {
        inputFocus.addEventListener('keypress', this.handleInputEvent)
      }
    }
  }

  handleInputEvent = (event: KeyboardEvent) => {
    const { handleInputChange } = this.props
    if (handleInputChange) {
      handleInputChange(event.key)
    }
  }

  handleSubmit = () => {
    const googleCustomSearch = document.getElementById(
      'google-custom-search-input',
    )
    if (googleCustomSearch) {
      const btn = googleCustomSearch.getElementsByTagName('button')[0]
      if (btn) {
        btn.click()
      }
    }
  }

  createGoogleSearchBox = () => {
    const { type, restrictedLanguages, newWindow, resultsPageUrl } = this.props
    switch (type) {
      case 'searchbox': {
        return {
          __html: `<gcse:searchbox newWindow=${newWindow} language=fr enableAutoComplete=true lr=${restrictedLanguages}></gcse:searchbox>`,
        }
      }
      case 'searchbox-only': {
        return {
          __html: `<gcse:searchbox-only enableAutoComplete=true resultsUrl=${resultsPageUrl} lr=${restrictedLanguages}></gcse:searchbox-only>`,
        }
      }

      // no default
    }
  }

  render() {
    const {
      className,
      searchTitleText,
      searchResultsLabelText,
      submitButtonText,
    } = this.props

    return (
      <MediaQuery tablet>
        {({ belowTablet }) => (
          <div className={classNames(style.wrapper, className)}>
            {belowTablet ? (
              <HeadlineThree className={style.searchTitleContainer}>
                {searchTitleText}
              </HeadlineThree>
            ) : (
              <HeadlineTwo className={style.searchTitleContainer}>
                {searchTitleText}
              </HeadlineTwo>
            )}
            <div
              className={style.searchInputContainer}
              dangerouslySetInnerHTML={this.createGoogleSearchBox()}
              id='google-custom-search-input'
            />
            <div className={style.searchSubmitContainer}>
              <Button
                aria-label={searchResultsLabelText}
                className={style.searchSubmitButton}
                variant='primaryBlue'
                onClick={this.handleSubmit}
              >
                {submitButtonText}
              </Button>
            </div>
          </div>
        )}
      </MediaQuery>
    )
  }
}

export default SearchInput
